import React, { useState } from 'react'
import { TextField, Button } from "@mui/material";
import userServices from '../services/users'
import loginServices from '../services/login'
import blogServices from '../services/blogs'

function SignupForm ({ setUser }) {
  const [ username, setUsername ] = useState('')
  const [ name, setName ] = useState('')
  const [ password, setPassword ] = useState('')

  const handleSignup = async (e) => {
    e.preventDefault()
    
    const newUser = {
      username,
      name,
      password
    }
    try {
      await userServices.create(newUser)
      const loginCredentials = {
        username: username,
        password: password
      }
      const returndeLoginUser = await loginServices.login(loginCredentials)
      window.localStorage.setItem('localUser', JSON.stringify(returndeLoginUser))
      blogServices.setToken(returndeLoginUser.token)
      setUser(returndeLoginUser)
      setUsername('')
      setName('')
      setPassword('')
    } catch (exception) {
      console.log(`exception: ${exception}`)
    }
  }

  return (
    <>
      <h1 style={{ color: 'rgb(255, 165, 0)' }}>Blog Saver</h1>
      <div className="body">
        <div className="column">
            <form onSubmit={handleSignup} className="form">
            <TextField
            className="input"
            name="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            type="text"
            placeholder="username"
            InputProps={{
                className: "input",
            }}
            />
            <TextField
            className="input"
            name="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            type="text"
            placeholder="name"
            InputProps={{
                className: "input",
            }}
            />
            <TextField
            className="input"
            name="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            placeholder="password"
            InputProps={{
                className: "input",
            }}
            />
            <Button type="submit">Signup</Button>
            </form>
        </div>
      </div>
    </>
  )
}

export default SignupForm